module.exports = __webpack_public_path__ + "static/media/SV_Block.80611e36.jpg";